export enum DivisionPickupType {
    SystemAssign = 0,
    EmployeeAssign = 1
}
